__turbopack_context__.v({
  "pill": "BadgePill-module-scss-module__6jAgOa__pill",
});
